
export type Agenti = {
  id?: string;
  coddip?: string;
  nomeagente?: string;
  ditta?: number;
  codagente?: string;
}

export type AgentiApiResponse = {
  results: Array<Agenti>;
  count: number;
};

export function mapJsonToAgentiApiResponse(jsonData: any): AgentiApiResponse {
  const mappedData: AgentiApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
        id: item.VBT10_ID,
        coddip: item.VBT10_CODDIP,
        nomeagente: item.VBT10_NOMEAGENTE,
        ditta: item.VBT10_DITTA,
        codagente: item.VBT10_CODAGENTE,
    })),
  };
  return mappedData;
}



export type ReportAgentiVersore = {
  nrrel?: number;
  ditta?: number;
  nomeditta?: string;
  codprog?: string;
  desprog?: string;
  codcli?: number;
  ragsoccli?: string;
  tipoprog?: string;
  statoprog?: string;
  coddip?: string;
  nomedip?: string;
  codatt?: string;
  desatt?: string;
  codnodo?: string;
  desnodo?: string;
  oreord?: number;
  note?: string;
  datains?: Date | null;
  datareg?: Date | null;
  tiponodo?: string;
  prezzo?: number;
  fatt?: string;
  opzfatt?: string;
  nrfatt?: number;
  annofatt?: number;
  imprigo?: number;
  codart?: string;
  codagente?: string;
  nomeagente?: string;
};

export type ReportAgentiVersoreApiResponse = {
  results: Array<ReportAgentiVersore>;
  count: number;
};

export function mapJsonToReportAgentiVersoreApiResponse(jsonData: any): ReportAgentiVersoreApiResponse {
  const mappedData: ReportAgentiVersoreApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      nrrel: item.VBT56_NRREL,
      ditta: item.VBT56_DITTA,
      nomeditta: item.VBT56_NOMEDITTA,
      codprog: item.VBT56_CODPROG,
      desprog: item.VBT56_DESPROG,
      codcli: item.VBT56_CODCLI,
      ragsoccli: item.VBT56_RAGSOCCLI,
      tipoprog: item.VBT56_TIPOPROG,
      statoprog: item.VBT56_STATOPROG,
      coddip: item.VBT56_CODDIP,
      nomedip: item.VBT56_NOMEDIP,
      codatt: item.VBT56_CODATT,
      desatt: item.VBT56_DESATT,
      codnodo: item.VBT56_CODNODO,
      desnodo: item.VBT56_DESNODO,
      oreord: item.VBT56_OREORD,
      note: item.VBT56_NOTE,
      datains: item.VBT56_DATAINS,
      datareg: item.VBT56_DATAREG,
      tiponodo: item.VBT56_TIPONODO,
      prezzo: item.VBT56_PREZZO,
      fatt: item.VBT56_FATT,
      opzfatt: item.VBT56_OPZFATT,
      nrfatt: item.VBT56_NRFATT,
      annofatt: item.VBT56_ANNOFATT,
      imprigo: item.VBT56_IMPRIGO,
      codart: item.VBT56_CODART,
      codagente: item.VBT56_CODAGENTE,
      nomeagente: item.VBT56_NOMEAGENTE,
    })),
  };

  return mappedData;
}




export type EmailForm = {
    email :string;
    subject :string;
    // message :string;
    attachment :string;
    tipo :string;
  };


export type ReportDateForm = {
                fromDate?     :Date;
                toDate?      :Date;
                emailTo?      :string;
  };





